import React, { useEffect } from "react";
import { Modal, TextField, Button, styled } from "@mui/material";
import { IFlightTemplate } from "@vmosolutions/oc-interfaces";
import { useDispatch } from "react-redux";
import { updateFileTemplate } from "src/redux/actions/FlightBuilder.Actions";
import { ModalErrorText } from "../DialogModal/DialogModalComponents";

interface IRenameNodeModalProps {
  open: boolean;
  closeModal: () => void;
  activeNode: IFlightTemplate;
}

function getModalStyle(): any {
  const top = 50; // + rand();
  const left = 50; // + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const OCRenameNodeModal = styled("div")(({ theme }) => ({
  position: "absolute",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  border: "2px solid #000",
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
  display: "flex",
  flexDirection: "column",
}));

export const RenameNodeModal = (props: IRenameNodeModalProps): JSX.Element => {
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [fileName, setFileName] = React.useState("");
  const [error, setError] = React.useState("");
  const dispatch = useDispatch();

  const { open, closeModal, activeNode } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setFileName(event.target.value);
  };

  const renameNode = (): void => {
    if (fileName) {
      dispatch(updateFileTemplate({ ...activeNode, fileName }));
      closeModal();
    } else {
      setError("Requires new name");
    }
  };

  //clear form title
  useEffect(() => {
    if (!open) {
      setFileName("");
      setError(""); //reset to default
    }
  }, [open]);

  return (
    //@ts-ignore
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      onClick={(event) => event.stopPropagation()}
    >
      <OCRenameNodeModal style={modalStyle}>
        <h2 id="simple-modal-title">Rename {activeNode.fileName}</h2>
        <TextField id="simple-modal-description" label="New Name" value={fileName} onChange={handleChange} />
        {!!error && <ModalErrorText error={error}></ModalErrorText>}
        <Button id="rename_btn" color="primary" onClick={renameNode}>
          {" "}
          Rename
        </Button>
      </OCRenameNodeModal>
    </Modal>
  );
};
